<template>
  <div id='player-item' @click="jumpToPlayerPage(player.playerId)">
    <playerAvatar id='avatar' :playerId='player.playerId.toString()'/>
    <div>
      <div>{{ player.playerName }}</div>
      <div v-if='player.jerseyNumber'>{{ player.jerseyNumber + $t('teamPlayerList.number') }}</div>
    </div>
  </div>
</template>

<script>
import playerAvatar from '@/components/PlayerAvatar'
import { pageJumpMixin } from '@/views/basketball'

export default {
  name: 'player-item',
  props: {
    player: {
      type: Object,
      required: true
    }
  },
  mixins: [ pageJumpMixin ],
  components: {
    playerAvatar
  }
}
</script>

<style lang="sass" scoped>
$itemMargin: 15px
#player-item
  display: flex
  padding: 12px $itemMargin
  width: calc(50% - #{$itemMargin * 2})

  > div // column 2
    display: flex
    flex-direction: column
    justify-content: space-around
    overflow: hidden

    > div:first-child // player name
      font-size: 14px
      color: #333333
      overflow: inherit
      text-overflow: ellipsis
      white-space: nowrap

    > div:nth-child(2) // jersey number
      font-size: 12px
      color: #999999

$avatarWidth: 36px
#avatar
  width: $avatarWidth
  height: $avatarWidth
  border: 1px solid #dcdcdc
  margin-right: 10px
  flex-shrink: 0

</style>
